import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconCookie } from '@tabler/icons-react';
import { useAuth } from '../context/AuthContext';
import { acceptCookieConsent, hasCookieConsent } from '../utils/cookieConsent';
import { track } from '../utils/analytics';
import './CookieBanner.scss';

const PATHS_WITH_BOTTOM_NAV = ['/', '/subscriptions', '/account', '/links'];

export default function CookieBanner() {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    const [visible, setVisible] = useState(() => !hasCookieConsent());

    if (isLoading || !isAuthenticated || !visible) {
        return null;
    }

    const withBottomNav = PATHS_WITH_BOTTOM_NAV.includes(location.pathname);

    const handleAccept = () => {
        acceptCookieConsent();
        setVisible(false);
        track('cookie_consent_accepted');
    };

    return (
        <div
            className={`cookie-banner${withBottomNav ? ' cookie-banner--with-bottom-nav' : ''}`}
            role="dialog"
            aria-labelledby="cookie-banner-title"
            aria-describedby="cookie-banner-text"
        >
            <div className="cookie-banner__inner">
                <IconCookie
                    size={22}
                    stroke={1.5}
                    className="cookie-banner__icon"
                    aria-hidden="true"
                />
                <div className="cookie-banner__content">
                    <h2 id="cookie-banner-title" className="cookie-banner__title">
                        Уведомление о cookie
                    </h2>
                    <p id="cookie-banner-text" className="cookie-banner__text">
                        Продолжая использовать сайт, вы даете
                        {' '}
                        <Link to="/privacy" className="cookie-banner__link">
                            согласие
                        </Link>
                        {' '}
                        на обработку cookie-файлов. Если вы не хотите, чтобы эти данные обрабатывались, просим отключить обработку в настройках вашего браузера или покинуть сайт
                    </p>
                    <button
                        type="button"
                        className="btn btn--primary cookie-banner__accept"
                        onClick={handleAccept}
                    >
                        Принять
                    </button>
                </div>
            </div>
        </div>
    );
}
